import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import ButtonWithToolTip from 'components/ButtonWithToolTip';
import messages from 'containers/QuestionnairePage/QuestionGroup/ABTest/Concepts/messages';

function Attribute({ attribute, intl }) {
  return (
    <div className="display-flex flex-items-center w-full">
      <div className="background-grey-4 text-size-secondary border-radius-level-1 padding-xs">
        <span className="text-size-secondary margin-right-tiny">
          A{attribute.index + 1}
        </span>
        <input
          type="text"
          maxLength="40"
          value={attribute.name}
          readOnly
          placeholder={intl.formatMessage(messages.attributePlaceholder, {
            index: attribute.index + 1,
          })}
          style={{
            width: 79,
          }}
          className="outline-none color-grey-10 color-grey-8-placeholder"
        />
      </div>
      <ButtonWithToolTip
        disabled
        tooltip={messages.removeAttribute}
        iconType="close"
      />
    </div>
  );
}

Attribute.propTypes = {
  attribute: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(Attribute);
